import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ContentTypeAppLabels = {
  AP: 'ap',
  APPROVAL: 'approval',
  CONTRACT: 'contract',
  CUSTOM_FIELD: 'custom_field',
  EXPORTER: 'exporter',
  PAYMENT: 'payment',
  PROCURE: 'procure',
  PROCURIFY: 'procurify',
  RECEIPT: 'receipt',
  RECONCILE: 'reconcile',
  PAY: 'pay',
  COMMON: 'common',
  VENDOR: 'vendor',
} as const

export type ContentTypeAppLabelEnum = Enum<typeof ContentTypeAppLabels>
